


















import { Component, Prop, Vue } from 'vue-property-decorator';
import { ComponentProps } from './types';
import ButtonDefault from '@/components/parts/button';

@Component({
  components: {
    ButtonDefault,
  },
})
export default class PresetButtonCanRequest
  extends Vue
  implements ComponentProps {
  // Props
  @Prop({ type: Boolean, required: true })
  isPossible: boolean;

  @Prop({ type: String, default: 'disabled' })
  impossibleColor: string;

  @Prop({ type: String, default: 'Запись приостановлена' })
  impossibleText: string;

  @Prop({ type: String, default: 'Ожидаем расписание' })
  scheduleText: string;

  @Prop({ type: Boolean, default: false })
  isNoSchedule: boolean;

  @Prop({ type: Boolean, default: false })
  isClass: boolean;

  @Prop({ type: String, default: 'lime' })
  possibleColor: string;

  @Prop({ type: String, default: 'Записаться' })
  possibleText: string;

  @Prop({ type: String, default: 'Вы уже записались' })
  alreadyRequestedText: string;

  @Prop({ type: String, default: '' })
  requestTooltipText: string;

  @Prop({ type: String, default: 'small' })
  size: string;

  @Prop({ type: Number, default: 1.4 })
  factor: number;

  @Prop({ type: Boolean, default: false })
  block: boolean;

  @Prop({ type: Boolean, default: false })
  disabledRequest: boolean;

  offTooltip: boolean = false;

  // Computed
  get color(): string {
    const { possibleColor, impossibleColor, disabled } = this;
    return disabled ? impossibleColor : possibleColor;
  }

  get disabled(): boolean {
    const { isPossible, isNoSchedule, isClass, disabledRequest } = this;
    if (!isPossible || disabledRequest) return true;
    return !isClass && isNoSchedule;
  }

  get text(): string {
    const {
      isPossible,
      isNoSchedule,
      possibleText,
      impossibleText,
      scheduleText,
      isClass,
      disabledRequest,
      alreadyRequestedText,
    } = this;
    if (!isPossible) return impossibleText;
    return !isClass && isNoSchedule
      ? scheduleText
      : disabledRequest
      ? alreadyRequestedText
      : possibleText;
  }

  // Methods
  onClick(event: Event): void {
    const { isPossible, isNoSchedule, isClass } = this;
    if (!isPossible) return;
    if (isClass || !isNoSchedule) {
      this.$emit('click', event);
    }
  }

  tooltipClick(): void {
    this.offTooltip = true;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/presets/button/can-request/component.vue